import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { default: FormsPlayground } = await import('./index');
    return {
        Component: FormsPlayground,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
